<a (click)="navigateBack()">
  <icon-chevrons-left class="mr-05"></icon-chevrons-left>
  <span class="link-text">{{navText}}</span>
</a>

